import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OnAccountBadStateActionMessage {
    mailboxInfo: MailboxInfo;
}
const defaultExport: (mailboxInfo: MailboxInfo) => OnAccountBadStateActionMessage = action(
    'onAccountBadState',
    (mailboxInfo: MailboxInfo): OnAccountBadStateActionMessage => ({
        mailboxInfo,
    })
);
export default defaultExport;
